import DataTable from "../../../components/data-table/data-table";
import { alertcaseColumns } from "../alertcases-columns";

interface IAlertCasesProps {
  onActionClick?: (action_key: string, rowId: string) => void;
  onBeforeRowClick?: (rowId: string) => Promise<boolean>;
}

const AllAlertCases = ({onActionClick, onBeforeRowClick}: IAlertCasesProps) => {
  return <div className="allAlertCases">
    <DataTable
      defaultSortCol="creation_date"
      columns={alertcaseColumns}
      defaultSortDirection="desc"
      style="compact"
      dataUrl={{
        url: "alertcases",
        backend: "manager"
      }}
      selectionMode="off"
      onActionClick={onActionClick}
      onBeforeRowClick={onBeforeRowClick}
    />
  </div>;
};

export default AllAlertCases;  